import { Box, Card, Skeleton, Typography } from '@mui/material'
import { ReactElement } from 'react'
import type { IBSCProgressData } from '../ibsc.slice'

type Props = {
  data?: IBSCProgressData
  isLoading: boolean
}

type StatCardProps = {
  label: string
  value: string
  color: string
}

let StatCard = (props: StatCardProps): ReactElement => {
  let { label, value, color } = props

  return (
    <Card
      sx={{
        flex: 1,
        p: 3,
        backgroundColor: 'background.paperDark',
        border: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        minWidth: 100,
      }}
    >
      <Typography
        variant="h3"
        sx={{ color, fontWeight: 700, fontSize: '2rem', lineHeight: 1.2 }}
      >
        {value}
      </Typography>
      <Typography
        color="text.secondary"
        variant="body2"
        sx={{
          mt: 0.5,
        }}
      >
        {label}
      </Typography>
    </Card>
  )
}

export default (props: Props): ReactElement => {
  let { data, isLoading } = props

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          mb: 3,
          flexWrap: 'wrap',
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{ flex: 1, minWidth: 100, height: 100, borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          sx={{ flex: 1, minWidth: 100, height: 100, borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          sx={{ flex: 1, minWidth: 100, height: 100, borderRadius: 1 }}
        />
      </Box>
    )
  }

  if (!data) return <></>

  let totalHours = data.ibsc40.totalHours + data.ibsc100.totalHours
  let totalCerts =
    data.ibsc40.certificates.length + data.ibsc100.certificates.length

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      <StatCard
        label="Total Hours"
        value={totalHours.toFixed(1)}
        color="primary.main"
      />
      <StatCard
        label="Certificates"
        value={String(totalCerts)}
        color="success.main"
      />
      <StatCard
        label="Total Completion"
        value={`${data.overallCompletionPercent}%`}
        color="warning.main"
      />
    </Box>
  )
}
